<template>
  <div>
    <validation-observer ref="documentFormRef" v-slot="{}" tag="form">
      <div class="row">
        <div class="col-5">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="fileSelected.documentType"
              :clearable="true"
              custom-error-msg="El tipo de documento es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="value"
              label="Tipo de Documento:"
              :options="documentTypeList"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-5 mt-4 pt-2">
          <validation-provider
            v-slot="{ errors }"
            name="fileUpload"
            rules="required"
          >
            <custom-file-input
              id="customInptFileUploadDocumentsPdf"
              ref="documentInputRef"
              :accept="'pdf'"
              class="file-input__extended"
              :custom-error-msg="'El documento es requerido.'"
              display-style="normal"
              :error="errors[0]"
              :on-download="() => {}"
              required
              :value="fileSelected.file"
              @after-remove="resetFile"
              @input="onFileChanged"
            />
          </validation-provider>
        </div>
        <div class="d-flex justify-content-end col-2 mt-2">
          <action-button
            i="fas fa-file-plus fa-lg pl-2 mt-1 mb-1"
            text="Añadir"
            variant="success mt-4 mb-4  pr-3 pl-0"
            @click="onAddDocument"
          />
        </div>
      </div>
      <div class="col-4" />
    </validation-observer>
    <div>
      <custom-callout
        v-for="(document, index) in addedDocuments"
        :key="`${document.id}-${index}`"
        class-main="mt-3 rounded"
        :controlled="true"
        :has-border="false"
        :has-toggle="false"
      >
        <div class="row">
          <div class="col-5">
            <label class="color-gray-6 d-block font-14">
              Tipo de Documento:
            </label>
            <span>{{ document.documentTypeName }}</span>
          </div>
          <div class="col-5">
            <label class="color-gray-6 d-block font-14">Archivo:</label>
            <span>{{ document.name }}</span>
          </div>
          <div class="col-2">
            <action-button
              i="fas fa-file-search color-green"
              text="Ver Documento"
              variant="outline-success"
              @click="downloadDocument(document.id)"
            />
          </div>
        </div>
      </custom-callout>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import objectToFormData from 'object-to-formdata';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

import { saveDocument as _saveDocument } from '@/services/provider/compensatoryRequest.api';
import { getRequestDocumentsByRequestId as _getRequestDocumentsByRequestId } from '@/services/provider/extended-academic-year.api';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';

export default {
  name: 'CompensatoryServiceDocuments',
  mixins: [alertMixin],
  components: {
    CustomDropDown,
    CustomFileInput,
    ActionButton,
    CustomCallout,
  },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
    requestStatusId: {
      type: Number,
      required: true,
    },
    academicYearId: {
      type: Number,
      required: true,
    },
    addRejectDocType: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      documentTypeList: [],
      fileSelected: {
        documentType: null,
        name: null,
        file: null,
      },
      addedDocuments: [],
    };
  },
  methods: {
    resetFile() {
      this.fileSelected = {
        documentType: null,
        name: null,
        file: null,
      };
    },
    onFileChanged(file) {
      if (file) {
        this.fileSelected.name = file.name;
        this.fileSelected.file = file;
      }
    },
    async loadRequestDocuments() {
      await _getRequestDocumentsByRequestId(
        this.academicYearId,
        this.requestId
      ).then((resp) => {
        if (resp.data) {
          resp.data.forEach((d) => {
            if (!d.filename) {
              this.documentTypeList.push({
                id: d.documentTypeId,
                value: d.documentTypeName,
              });
            }

            if (d.filename) {
              this.addedDocuments.push({
                documentTypeName: d.documentTypeName,
                name: d.filename,
                id: d.documentId,
              });
            }
          });
        }
      });
    },
    async downloadDocument(documentId) {
      await _downloadDocumentByAttachmentId(documentId);
    },
    async onAddDocument() {
      const isValid = await this.$refs.documentFormRef.validate();
      if (!isValid) return;

      let payload = objectToFormData({
        compensatoryRequestId: this.requestId,
        fileName: this.fileSelected.name,
        documentTypeId: this.fileSelected.documentType.id,
        file: this.fileSelected.file,
      });

      await _saveDocument(payload)
        .then((resp) => {
          let doc = {
            ...this.fileSelected,
            documentTypeName: this.fileSelected.documentType.value,
            id: resp.data,
          };
          this.addedDocuments.push(doc);
          this.$refs.documentInputRef.removeFile();
          this.resetFile();
          this.$refs.documentFormRef.reset();
          this.ShowToast(
            'Proceso Exitoso.',
            'El documento se a agregado exitosamente.',
            'success'
          );
        })
        .catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response?.data.message || 'error',
            'error'
          );
        });
    },
  },
  mounted() {
    this.loadRequestDocuments();
  },
};
</script>
